module.exports = __webpack_public_path__ + "static/media/TubeStandXLShort.dc1733ee.svg";